import { render, staticRenderFns } from "./IconSvgNPMAMyNPMA.vue?vue&type=template&id=0c61e6eb&scoped=true&"
import script from "./IconSvgNPMAMyNPMA.vue?vue&type=script&lang=js&"
export * from "./IconSvgNPMAMyNPMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61e6eb",
  null
  
)

export default component.exports